import { Route, Switch } from "react-router-dom";
import { useEagerConnect } from "./services/web3/hooks";
import { SnackbarProvider } from "notistack";
import AOS from "aos";

import Home from "./components/Home";
import SignUp from "./components/Auth/SignUp";
import LogIn from "./components/Auth/LogIn";
import ValidateEmail from "./components/Auth/ValidateEmail";
import ConfirmToken from "./helpers/ConfirmToken";
import RecoverPassword from "./components/Auth/RecoverPassword";
import ChangePassword from "./components/Auth/ChangePassword";
import VerificationCode from "./components/Auth/VerificationCode";
import AllModal from "./components/Modals/AllModal";
import LockTokens from "./components/LockTokens/LockTokens";
import LearnResult from "./components/Learn2/LearnResult";
import Invest from "./components/Invest/Invest";
import InvestSuccess from "./components/Invest/InvestSuccess";
import PersonalInfo from "./components/Profile/PersonalInfo";
import Portfolio from "./components/Portfolio";
import Wallets from "./components/Wallets";
import IdentityVerification from "./components/IdentityVerification/IdentityVerification";
import Alerts from "./helpers/Alerts";
import PrivateRoute from "./components/PrivateRoutes";
import Gains from "./components/Gains";
import NotFound from "./components/404/NotFound";
import ProjectPools from "./components/Projects/ProjectPools";
import LearnPage from "./components/Learn2/LearnPage";
import LearnCongrat from "./components/Learn2/LearnSuccess";
import LearnFail from "./components/Learn2/LearnFail";
import PoolDetail from "./components/ProjectDetail";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../src/assets/fonts/icomoon/style.css";
import "../src/assets/fonts/aspekta/style.css";
import "aos/dist/aos.css";
import '@rainbow-me/rainbowkit/styles.css';
import Terms from "./components/Terms";
import IdoStepByStep from "./components/IdoStepByStep";
import ChangeEmailConfirmation from "./components/Profile/ChangeEmailConfirmation";

AOS.init({
  once: true,
});

const App = () => {
  useEagerConnect();
  return (
      <SnackbarProvider
        iconVariant={{
          error: " ",
        }}
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableWindowBlurListener={true}
      >
        <Alerts />
        <Switch>

          <Route exact path="/signup" component={SignUp} />
          <Route exact path="/login" component={LogIn} />
          <Route
            exact
            path="/email-validate/:email"
            children={<ValidateEmail />}
          />
          <Route
            exact
            path="/register/confirm/:token"
            children={<ConfirmToken />}
          />
          <Route exact path="/recover-password" component={RecoverPassword} />
          <Route exact path="/reset-password/:token" component={ChangePassword} />
          <Route exact path="/verification-code" component={VerificationCode} />
          <Route exact path="/deals" component={ProjectPools} />
          <Route path="/project/:id" component={PoolDetail} />
          <PrivateRoute exact path="/all-modal" component={AllModal} />
          <PrivateRoute exact path="/lock-tokens/:ids" component={LockTokens} />
          <PrivateRoute exact path="/learn/:id" component={LearnPage} />
          <PrivateRoute exact path="/learn-result/:id" component={LearnResult} />
          <PrivateRoute exact path="/learn-result-congrat" component={LearnCongrat} />
          <PrivateRoute exact path="/learn-result-fail" component={LearnFail} />
          <PrivateRoute exact path="/invest/:id" component={Invest} />
          <PrivateRoute
            exact
            path="/investment-successful"
            component={InvestSuccess}
          />
          <PrivateRoute exact path="/profile-settings/:tabIndex?" component={PersonalInfo} />
          <PrivateRoute exact path="/profile-settings/change-email/confirm/:token" component={ChangeEmailConfirmation} />
          <PrivateRoute exact path="/portfolio" component={Portfolio} />
          <PrivateRoute exact path="/wallets" component={Wallets} />
          <PrivateRoute exact path="/gains" component={Gains} />
          <PrivateRoute
            exact
            path="/identity-verification"
            component={IdentityVerification}
          />

          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/terms">
            <Terms />
          </Route>
          <Route exact path="/ido-step-by-step">
            <IdoStepByStep />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </SnackbarProvider>
  );
};

export default App;
